import React from "react";
import { Sparkles } from "lucide-react";

const SampleBadge: React.FC = () => {
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-amber-100 text-amber-700 border border-amber-200"
      title="This is example data to help you get started. It will be automatically deleted when your free trial ends."
    >
      <Sparkles className="h-3 w-3" />
      Example
    </span>
  );
};

export default SampleBadge;
